import {
  CcfBox,
  CcfCheckBoxIcon,
  CcfCheckBoxOutlineBlankIcon,
  CcfSearchIcon,
  CcfTextField,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { evaluationsData } from './evalutionMockData';
import { makeStyles } from '@mui/styles';
import {
  Checkbox,
  FormControlLabel,
  InputAdornment,
  MenuItem,
  Select,
} from '@mui/material';
import { wemSessionsTabData } from './wemSessionsTabData';

/* eslint-disable-next-line */
export interface CcfWemCoachingSessionsTabProps {
  setisSessionSelected: any;
  isSessionSelected: any;
  selectedSession: any;
  setSelectedSession: any;
}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      Height: '330px',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      cursor: 'pointer',
      color: '#333333',
    },
  },
  searchInput: {
    '&.MuiOutlinedInput-input': {
      border: '0',
      height: '15px',
    },
  },
});

/**
 * CcfWemEvaluations - used to display wem evaluations
 * @param props - CcfWemEvaluations
 * @example `<CcfWemEvaluations />`
 */
export function CcfWemCoachingSessionsTab(
  props: CcfWemCoachingSessionsTabProps
) {
  const {
    setisSessionSelected,
    isSessionSelected,
    selectedSession,
    setSelectedSession,
  } = props;
  const classes = useStyles();
  const [rowData, setRowData]: any = useState([]);
  const [checkboxData, setCheckboxData]: any = useState({
    AwaitingAcknowledgment: true,
    completed: true,
    scheduled: true,
    overdue: true,
  });
  const [translate] = useTranslator();

  const [dropdownData, setDropdownData] = useState('Current Quarter');
  const columns = [
    {
      field: 'focusArea',
      headerName: 'focus area'.toUpperCase(),
      width: 155,
      renderCell: (params: any) => {
        return (
          <CcfBox
            onClick={() => {
              setSelectedSession(params.row);
            }}
          >
            {' '}
            {params.value}{' '}
          </CcfBox>
        );
      },
    },
    {
      field: 'metric',
      headerName: 'metric'.toUpperCase(),
      width: 80,
    },
    {
      field: 'coachingType',
      headerName: 'coaching type'.toUpperCase(),
      width: 130,
    },
    {
      field: 'coachName',
      headerName: 'coach name'.toUpperCase(),
      width: 150,
    },
    {
      field: 'coachingDate',
      headerName: 'coaching date'.toUpperCase(),
      width: 130,
    },
    {
      field: 'lastUpdated',
      headerName: 'last updated'.toUpperCase(),
      width: 130,
    },

    {
      field: 'status',
      headerName: 'status'.toUpperCase(),
      width: 120,
      renderCell: (params: any) => {
        return (
          <CcfBox style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {' '}
            {params.row.status === 'Overdue' ? (
              <img
                src="./assets/OverdueIcon.png"
                alt="OverdueIcon"
                style={{ width: '18px' }}
              />
            ) : params.row.status === 'Completed' ? (
              <CheckCircleOutlineOutlinedIcon
                htmlColor={'#39C44A'}
                style={{ width: '20px' }}
              />
            ) : (
              <img
                src="./assets/Scheduled.png"
                alt="Scheduled"
                style={{ width: '18px' }}
              />
            )}
            {params.value}{' '}
          </CcfBox>
        );
      },
    },
    {
      field: 'schedule',
      headerName: 'schedule'.toUpperCase(),
      width: 90,
    },
    {
      field: 'acknowledgmentDueDate',
      headerName: 'ACKNOWLEDGMENT DUE DATE',
      width: 120,
      renderCell: (params: any) => {
        return (
          <CcfBox style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {params.value}{' '}
          </CcfBox>
        );
      },
    },
  ];
  useEffect(() => {
    const rd = wemSessionsTabData.map((x, i) => {
      return {
        id: i,
        focusArea: x.focusArea,
        metric: x.metric,
        coachingType: x.coachingType,
        coachName: x.coachName,
        coachingDate: x.coachingDate,
        lastUpdated: x.lastUpdated,
        status: x.status,
        schedule: x.schedule,
        acknowledgmentDueDate: x.acknowledgmentDueDate,
      };
    });

    setRowData(rd);
  }, []);
  /**
   * Handles the change event for input elements.
   * Updates the form data with the new value.
   * @param e - The change event.
   * @example
   */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setDropdownData(value);
  };
  return (
    <CcfBox>
      <CcfBox
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #d0d2d3',
        }}
      >
        <CcfBox className={styles.sessionTabSearchBar}>
          <CcfBox className={styles.searchCountText}>3 sessions</CcfBox>
          <CcfBox>
            <CcfTextField
              id="search Box"
              size="small"
              className={styles.coachingSearchBox}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <CcfSearchIcon htmlColor="grey" />
                  </InputAdornment>
                ),
                classes: { input: classes.searchInput },
              }}
              sx={{ marginLeft: '0px !important' }}
              placeholder="Search focus areas"
            />
          </CcfBox>
        </CcfBox>
        <CcfBox
          className={styles.sessionTabSearchBar}
          sx={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <CcfTypography style={{ fontWeight: '600', fontSize: '12px' }}>
            LAST UPDATED
          </CcfTypography>
          <CcfBox>
            <Select
              id={'selectControl'}
              className={styles.selectControl}
              name={dropdownData}
              value={dropdownData}
              onChange={(e: any) => handleChange(e)}
            >
              {[
                translate('currentMonth'),
                translate('previousMonth'),
                translate('currentQuarter'),
                translate('previousQuarter'),
                translate('previous12Month'),
              ].map((x: any) => (
                <MenuItem
                  key={x}
                  value={x}
                  style={{ fontSize: '13px', color: '#2e2e2e' }}
                >
                  {x}
                </MenuItem>
              ))}
            </Select>
          </CcfBox>
        </CcfBox>
      </CcfBox>
      <CcfBox className={styles.stateFilterWrapper}>
        <CcfBox style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            <FormControlLabel
              value="Awaiting Acknowledgment (0)"
              checked={checkboxData.AwaitingAcknowledgment}
              control={
                <Checkbox
                  color="primary"
                  icon={<CcfCheckBoxOutlineBlankIcon />}
                  checkedIcon={<CcfCheckBoxIcon />}
                  onChange={(e) => {
                    setCheckboxData({
                      ...checkboxData,
                      AwaitingAcknowledgment: e.target.checked,
                    });
                  }}
                />
              }
              sx={{
                ' .MuiFormControlLabel-label': {
                  fontWeight: '400',
                  fontSize: '13px',
                },
              }}
              label={
                <CcfBox style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src="./assets/TimeTableIcon.png"
                    alt="Scheduled"
                    style={{
                      marginRight: '5px',
                      width: '18px',
                    }}
                  />
                  Awaiting Acknowledgment (0)
                </CcfBox>
              }
              labelPlacement="end"
            />
          </div>
        </CcfBox>
        <CcfBox style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            <FormControlLabel
              value=" Completed (0)"
              checked={checkboxData.completed}
              control={
                <Checkbox
                  color="primary"
                  icon={<CcfCheckBoxOutlineBlankIcon />}
                  checkedIcon={<CcfCheckBoxIcon />}
                  onChange={(e) => {
                    setCheckboxData({
                      ...checkboxData,
                      completed: e.target.checked,
                    });
                  }}
                />
              }
              sx={{
                ' .MuiFormControlLabel-label': {
                  fontWeight: '400',
                  fontSize: '13px',
                },
              }}
              label={
                <CcfBox
                  style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                >
                  {' '}
                  <CheckCircleOutlineOutlinedIcon
                    htmlColor={'#39C44A'}
                    style={{ width: '20px' }}
                  />
                  Completed (0)
                </CcfBox>
              }
              labelPlacement="end"
            />
          </div>
        </CcfBox>
        <CcfBox style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            <FormControlLabel
              value="Scheduled (0)"
              checked={checkboxData.scheduled}
              control={
                <Checkbox
                  color="primary"
                  icon={<CcfCheckBoxOutlineBlankIcon />}
                  checkedIcon={<CcfCheckBoxIcon />}
                  onChange={(e) => {
                    setCheckboxData({
                      ...checkboxData,
                      scheduled: e.target.checked,
                    });
                  }}
                />
              }
              sx={{
                ' .MuiFormControlLabel-label': {
                  fontWeight: '400',
                  fontSize: '13px',
                },
              }}
              label={
                <CcfBox
                  style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                >
                  {' '}
                  <img
                    src="./assets/Scheduled.png"
                    alt="Scheduled"
                    style={{ width: '18px' }}
                  />
                  Scheduled (0)
                </CcfBox>
              }
              labelPlacement="end"
            />
          </div>
        </CcfBox>
        <CcfBox style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            <FormControlLabel
              value="Overdue (3)"
              checked={checkboxData.overdue}
              control={
                <Checkbox
                  color="primary"
                  icon={<CcfCheckBoxOutlineBlankIcon />}
                  checkedIcon={<CcfCheckBoxIcon />}
                  onChange={(e) => {
                    setCheckboxData({
                      ...checkboxData,
                      overdue: e.target.checked,
                    });
                  }}
                />
              }
              sx={{
                ' .MuiFormControlLabel-label': {
                  fontWeight: '400',
                  fontSize: '13px',
                },
              }}
              label={
                <CcfBox
                  style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                >
                  {' '}
                  <img
                    src="./assets/OverdueIcon.png"
                    alt="OverdueIcon"
                    style={{ width: '18px' }}
                  />
                  Overdue (3)
                </CcfBox>
              }
              labelPlacement="end"
            />
          </div>
        </CcfBox>
      </CcfBox>
      <CcfBox
        style={{
          height: '30vh',
          backgroundColor: '#f2f7fa',
          overflowY: 'hidden',
          borderTop: '1px solid #E1E1E1',
        }}
        id={`agent_wem_evaluation_dataGridContainer`}
      >
        <DataGrid
          classes={{ root: classes.root }}
          rows={rowData}
          columns={columns}
          rowHeight={40}
          getRowId={(row) => row?.id}
          pageSize={10}
          headerHeight={40}
          onRowClick={(params: any) => {
            setisSessionSelected(!isSessionSelected);
          }}
          // autoHeight
          disableSelectionOnClick
          pagination
          rowsPerPageOptions={[5, 10, 25]}
          getRowClassName={(params: any) => `styledrows`}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              color: '#3F5C69',
              fontWeight: '600',
              fontSize: '12px',
              fontFamily: 'Open Sans',
            },
          }}
        />
      </CcfBox>
    </CcfBox>
  );
}
